import React, { useState } from "react";
import { Box, Menu, MenuItem, ListItemIcon } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import CreateNewFolderOutlinedIcon from "@mui/icons-material/CreateNewFolderOutlined";
import QuizIcon from "@mui/icons-material/Quiz";
import AddIcon from "@mui/icons-material/Add";
import PlaylistAddCheckIcon from "@mui/icons-material/PlaylistAddCheck";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { TextIconButtonComponent } from "../../../../component/atom";

export const AddQuizFolderMenu = ({
  onCreateFolderClick,
  onCreateQuizClick,
  onSelectQuizClick,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [quizMenuAnchor, setQuizMenuAnchor] = useState(null);

  const openMenu = (event) => setAnchorEl(event.currentTarget);
  const closeMenu = () => {
    setAnchorEl(null);
    setQuizMenuAnchor(null);
  };

  return (
    <Box>
      <TextIconButtonComponent
        btnText={"Add New"}
        icon={faPlus}
        animation={"shake"}
        onclick={openMenu}
        endIcon={<KeyboardArrowDownIcon />}
      />

      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={closeMenu}>
        <MenuItem
          onClick={() => {
            closeMenu();
            onCreateFolderClick();
          }}
          sx={{
            py: 1.5,
            gap: 1,
            "&:hover": { backgroundColor: "rgba(122, 41, 192, 0.12) !important" },
          }}
        >
          <ListItemIcon sx={{ minWidth: 36, color: "#9834F0" }}>
            <CreateNewFolderOutlinedIcon fontSize="small" />
          </ListItemIcon>
          Create Folder
        </MenuItem>

        <MenuItem
          onClick={(e) => setQuizMenuAnchor(e.currentTarget)}
          sx={{
            py: 1.5,
            gap: 1,
            "&:hover": { backgroundColor: "rgba(122, 41, 192, 0.12) !important" },
          }}
        >
          <ListItemIcon sx={{ minWidth: 36, color: "#9834F0" }}>
            <QuizIcon fontSize="small" />
          </ListItemIcon>
          Add Quiz
        </MenuItem>
      </Menu>

      {/* Nested Menu for Quiz Options */}
      <Menu
        anchorEl={quizMenuAnchor}
        open={Boolean(quizMenuAnchor)}
        onClose={() => setQuizMenuAnchor(null)}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        <MenuItem
          onClick={() => {
            closeMenu();
            onCreateQuizClick();
          }}
        >
          <ListItemIcon sx={{ minWidth: 30, color: "#9834F0" }}>
            <AddIcon fontSize="small" />
          </ListItemIcon>
          Create Quiz
        </MenuItem>

        <MenuItem
          onClick={() => {
            closeMenu();
            onSelectQuizClick();
          }}
        >
          <ListItemIcon sx={{ minWidth: 30, color: "#9834F0" }}>
            <PlaylistAddCheckIcon fontSize="small" />
          </ListItemIcon>
          Select Quiz
        </MenuItem>
      </Menu>
    </Box>
  );
};